"use strict";

exports.__esModule = true;
exports.SDKNotReady = exports.MethodNotFound = exports.BelowExistentialDeposit = void 0;
class MethodNotFound extends Error {
  constructor(section, method) {
    super();
    this.section = void 0;
    this.method = void 0;
    this.section = section;
    this.method = method;
    this.message = `can't find ${section}.${method} in api`;
    this.name = 'MethodNotFound';
  }
}
exports.MethodNotFound = MethodNotFound;
class SDKNotReady extends Error {
  constructor(name) {
    super();
    this.message = `SDK ${name} is not ready`;
    this.name = 'SDKNotReady';
  }
}
exports.SDKNotReady = SDKNotReady;
class BelowExistentialDeposit extends Error {
  constructor(address, token) {
    super();
    this.name = 'BelowExistentialDeposit';
    this.message = `The ${address}'s ${token.display} balance may below the existential deposit after this action`;
  }
}
exports.BelowExistentialDeposit = BelowExistentialDeposit;